import { gql } from "apollo-boost";

export const GET_USERS = gql`
  query(
    $userId: Int
    $userEmail: String
    $password: String
    $googleId: String
    $facebookId: String
  ) {
    allUser(
      userId: $userId
      userEmail: $userEmail
      password: $password
      googleId: $googleId
      facebookId: $facebookId
    ) {
      edges {
        node {
          userId
          userName
          userEmail
          gender
          createDate
          password
          passwordResetcode
          photo
          role
          birthDate
          state
          country
          language
          googleId
          facebookId
          id
          userAccess {
            edges {
              node {
                seqNo
                userId
                clubId
                accessLevel
                isDefault
                club {
                  clubName
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_USER_ACCESS = gql`
  query allUserAcces {
    allUserAcces {
      edges {
        node {
          seqNo
          userId
          clubId
          accessLevel
        }
      }
    }
  }
`;
